import * as React from 'react';

import {Button} from 'shells/button/button';
import {colors} from 'shells/colors/colors';
import {EmptyStateLarge} from 'shells/empty-states/empty-state-large';
// @ts-expect-error - imported from .js/.jsx file
import {UpgradeArrowIcon} from 'shells/icon/svg/upgrade-arrow-icon';
import {Illustration} from 'shells/illustrations/illustration';
import {Divider} from 'shells/layout/divider';
import {StackLegacy} from 'shells/layout/stack/stack-legacy';
import {Link} from 'shells/link/link';
import {Body} from 'shells/typography/body';

import {RouteContext} from '../../../route-context';

import {PrivacyPolicy} from '../../shared-components/privacy-policy';

type Props = {
    errorMessage?: string;
    setIsOnboardingModalOpen?: (isOnboardingModalOpen: boolean) => void;
};

export function SettingsNoIntegration(props: Props) {
    const isEmbedded = React.useContext(RouteContext).isEmbedded;

    return (
        <div className='flex'>
            <EmptyStateLarge
                title={`${isEmbedded ? 'Inbox FX' : ' Nutshell'} + WhatsApp Business`}
                detailTextBullets={[
                    `Send and receive WhatsApp messages via ${
                        isEmbedded ? 'Inbox FX' : 'the Nutshell inbox'
                    }`,
                    'Create leads from new messages',
                    `Choose to sync your WhatsApp contacts and chat history into ${
                        isEmbedded ? 'Inbox FX' : 'Nutshell'
                    }`,
                ]}
                icon={
                    isEmbedded ? (
                        <Illustration src='whatsapp-bubble' width={250} />
                    ) : (
                        <Illustration src='nutshell-plus-whatsapp-bubble' width={250} />
                    )
                }
                iconSide='right'
                cta={
                    <StackLegacy spacing={16} alignCenter={true}>
                        {NutClientConfig.hasWhatsApp ? (
                            <Button
                                variant='primary'
                                size='big'
                                onClick={() => {
                                    if (props.setIsOnboardingModalOpen) {
                                        props.setIsOnboardingModalOpen(true);
                                    }
                                }}
                            >
                                Connect your WhatsApp Business account
                            </Button>
                        ) : (
                            <Link
                                icon={UpgradeArrowIcon}
                                href='/setup/billing/sales'
                                variant='button-upgrade'
                                size='big'
                            >
                                Upgrade to get started
                            </Link>
                        )}
                        {props.errorMessage && (
                            <Body size='small' color='error'>
                                {props.errorMessage}
                            </Body>
                        )}
                        <StackLegacy isHorizontal={true} spacing={8}>
                            <Link
                                href='https://support.nutshell.com/en/articles/11487542-whatsapp-send-receive-messages-from-nutshell'
                                variant='primary'
                                newTab={true}
                                size='small'
                            >
                                Learn more
                            </Link>
                            <Divider variant='dot' color={colors.black} />
                            <PrivacyPolicy variant='primary' size='small' isEmbedded={isEmbedded} />
                        </StackLegacy>
                    </StackLegacy>
                }
            />
        </div>
    );
}
